var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"adblock mt-0"},[_c('div',{staticClass:"img"},[_vm._v(" Google AdSense"),_c('br'),_vm._v(" 336 x 280 ")])])}]

export { render, staticRenderFns }